import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DatetimeSelect from "components/Custom/DatetimeSelect";
import DocumentsTable from "components/Tables/DocumentsTable";
import moment from "moment";
import NetCard from "components/Cards/NetCard";
import DocsCard from "components/Cards/DocsCard";
import VatCard from "components/Cards/VatCard";

function DocumentStatsPage() {
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [totalVatAmount, setTotalVatAmount] = useState(0);
  const [numOfDocuments, setNumOfDocuments] = useState(0);

  const handleTableData = (data) => {
    let netTotal = 0;
    let vatTotal = 0;
    let count = 0;

    for (let doc of data) {
      //TODO: This is a hotfix to remove ΔΕΠΑ from documents...
      if (doc.code === "8.6") continue;
      netTotal += parseFloat(doc.net);
      vatTotal += parseFloat(doc.vat);
      count++;
    }
    setTotalNetAmount(netTotal);
    setTotalVatAmount(vatTotal);
    setNumOfDocuments(count);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="4" xs="12" sm="12">
            <NetCard totalNetAmount={totalNetAmount} />
          </Col>
          <Col lg="4" sm="12">
            <VatCard vatAmounts={totalVatAmount} />
          </Col>
          <Col lg="4" sm="12" xs="12">
            <DocsCard orders={numOfDocuments} />
          </Col>
        </Row>
        <Row>
          <Col lg="12" sm="12" md="12">
            <DocumentsTable sendData={handleTableData} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default DocumentStatsPage;
